export function generateSessionId() {
    return "s-".concat(Date.now(), "-").concat(Math.round(Math.random() * Math.pow(10, 10)));
}
//# sourceMappingURL=generateSessionId.js.map